export function articleListScripts(): void {
    const carousels = document.querySelectorAll("sl-carousel");
    if (carousels.length > 0) {
        carousels.forEach(carousel => {
            const resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    const width = entry.contentRect.width;
                    handleCarouselCards(carousel, width)
                }
            });
            resizeObserver.observe(carousel);
            const width = carousel.getBoundingClientRect().width;
            handleCarouselCards(carousel, width);
        })
    }

    function handleCarouselCards(carousel, width) {
        if (width < 768) {
            carousel.setAttribute("slides-per-page", "1")
            carousel.querySelectorAll("sl-card").forEach(card =>{
                card.classList.toggle("bg-article-card-two-cards", false)
                card.classList.toggle("bg-article-card-three-cards", false)
            })
        }
        if (width >= 768 && width < 1230) {
            carousel.setAttribute("slides-per-page", "2")
            carousel.querySelectorAll("sl-card").forEach(card =>{
                card.classList.toggle("bg-article-card-two-cards", true)
                card.classList.toggle("bg-article-card-three-cards", false)
            })

        }
        if (width >= 1230) {
            carousel.setAttribute("slides-per-page", "3")
            let cards = carousel.querySelectorAll("sl-card").forEach(card =>{
                card.classList.toggle("bg-article-card-two-cards", false)
                card.classList.toggle("bg-article-card-three-cards", true)
            })
        }
    }
}